// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Layout from './components/Layout';
// import Dashboard from './pages/Dashboard';
import LogIn from './auth/LogIn';
import { authService } from './apiServices/authService';
import Users from './pages/settings/Users';
import Contacts from './pages/others/Contacts';


const theme = createTheme({
    palette: {
        primary: {
            main: '#2E7D32',
        },
        secondary: {
            main: '#FF9800',
        },
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
});

// Protected Route component
const ProtectedRoute = ({ children }) => {
    if (!authService.isAuthenticated()) {
        return <Navigate to="/" replace />;
    }
    return children;
};

function App() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Router>
                <Routes>
                    {/* Public route */}
                    <Route path="/" element={<LogIn />} />
                    
                    {/* Protected routes with Layout */}

                    {/* dasshbord */}
                    {/* <Route path="/dashboard" element={ <ProtectedRoute> <Layout> <Dashboard /> </Layout> </ProtectedRoute>} /> */}
                    <Route path="/dashboard" element={ <ProtectedRoute> <Layout> <Contacts /> </Layout> </ProtectedRoute>} />
                    {/* <Route path="/users" element={ <ProtectedRoute> <Layout> <Users /> </Layout> </ProtectedRoute>} /> */}
                    <Route path="/Contacts" element={ <ProtectedRoute> <Layout> <Contacts /> </Layout> </ProtectedRoute>} />


                    
                    {/* Catch all - redirect to login */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </Router>
        </ThemeProvider>
    );
}

export default App;